import React, { useRef, useState } from "react";
import { ImageOff } from "lucide-react";

export default function Gallery({ images = [], name = "" }) {
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState({ show: false, x: 50, y: 50 });
  const imgRef = useRef(null);
  const current = images[active];

  const onMove = (e) => {
    const rect = imgRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setZoom({ show: true, x, y });
  };

  if (!images.length) {
    return (
      <div className="grid aspect-square w-full place-items-center rounded-2xl border border-border bg-secondary text-muted-foreground">
        <ImageOff size={40} />
      </div>
    );
  }

  return (
    <div className="flex flex-col-reverse gap-3 sm:flex-row" data-testid="product-gallery">
      <div className="no-scrollbar flex gap-3 overflow-x-auto sm:max-h-[520px] sm:w-20 sm:flex-col sm:overflow-y-auto">
        {images.map((img, i) => (
          <button
            key={i}
            onMouseEnter={() => setActive(i)}
            onClick={() => setActive(i)}
            className={`relative h-16 w-16 shrink-0 overflow-hidden rounded-xl border-2 transition ${i === active ? "border-brand" : "border-border"}`}
            data-testid={`gallery-thumb-${i}`}
          >
            <img src={img.src} alt={img.alt} className="h-full w-full object-cover" />
          </button>
        ))}
      </div>

      <div
        ref={imgRef}
        onMouseMove={onMove}
        onMouseLeave={() => setZoom((z) => ({ ...z, show: false }))}
        className="relative flex-1 overflow-hidden rounded-2xl border border-border bg-secondary"
      >
        <img
          src={current.src}
          alt={current.alt}
          className="aspect-square h-full w-full object-cover transition-transform duration-200"
          style={zoom.show ? { transform: "scale(1.8)", transformOrigin: `${zoom.x}% ${zoom.y}%` } : {}}
        />
      </div>
    </div>
  );
}
